import React from 'react';
import { ProFormDatePicker } from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import ProForm from 'components/layout/ProForm';

const ReportingPeriodForm = ({ onFinish, initialValues }) => {
  return (
    <ProForm
      requiredMark={false}
      onFinish={onFinish}
      initialValues={initialValues}
    >
      <ProFormDatePicker
        width="xl"
        name="startDate"
        label="Start Date"
        placeholder="YYYY-MM-DD"
        rules={[{ required: true }]}
      />
      <ProFormDatePicker
        width="xl"
        name="endDate"
        label="End Date"
        placeholder="YYYY-MM-DD"
        rules={[{ required: true }]}
      />
      <ProFormDatePicker
        width="xl"
        name="scheduledDeadline"
        label="Scheduled Deadline"
        placeholder="YYYY-MM-DD"
        rules={[{ required: true }]}
      />
    </ProForm>
  );
};

ReportingPeriodForm.defaultProps = {
  initialValues: {},
};

ReportingPeriodForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default ReportingPeriodForm;
